module.exports = __webpack_public_path__ + "static/media/rated.395aec03.svg";